import axios from "axios";
import { ApiSystem } from "../../state/types";

const headers = { Authorization: "bwenvdev" };

export const useSystemsApi = () => {

  const base = process.env.REACT_APP_UMS_API_BASE_URL;

  const createSystemApi = async (system: ApiSystem) => {
    await axios.post<ApiSystem>(`${base}/system/create`, system, { headers });
    return system;
  };

  const updateSystemApi = async (system: ApiSystem) => {
    await axios.put<ApiSystem>(`${base}/system`, { system }, { headers });
    return system
  };

  const deleteSystemApi = async (systemCode: string) => {
    await axios.delete(`${base}/system/${systemCode}`, { headers });
  };
  
  // The hook returns an object that matches our context's interface
  return {
    createSystemApi,
    updateSystemApi,
    deleteSystemApi
  };
};